import { Command } from '../command.model';

export class OpenInvationModalCommand implements Command {}
